module.exports = __webpack_public_path__ + "img/review-14.0ec06239.jpg";